import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	metrics: {
		data: {},
		error: '',
		isLoading: false,
		hasBeenLoaded: false
	}
};

export const metricsSlice = createSlice({
	name: 'metrics',
	initialState,
	reducers: {
		getMetrics: (state) => {
			state.metrics.isLoading = true;
		},
		getMetricsCompleted: (state, action) => {
			state.metrics.isLoading = false;
			state.metrics.data = action.payload;
			state.metrics.hasBeenLoaded = true;
			state.metrics.error = '';
		},
		getMetricsFailed: (state, action) => {
			state.metrics.isLoading = false;
			state.metrics.hasBeenLoaded = false;
			state.metrics.error = action.payload;
		}
	}
});

export const { getMetrics, getMetricsCompleted, getMetricsFailed } =
	metricsSlice.actions;

export default metricsSlice.reducer;
